export const REASONS = {
  missing_email: 'The client has no email address',
  missing_whatsapp_phone: 'The client has no WhatsApp phone number',
  whatsapp_unavailable: 'This phone number cannot receive WhatsApp messages',
  template_missing: 'There is no message template for the client\'s language',
  template_variables_unsupported: 'The WhatsApp template asks for details we do not have',
  template_variables_unavailable: 'Client details needed for the template are missing, for example the first name',
  trengo_channel_missing: 'The insurance WhatsApp line is not available',
  mailgun_disabled: 'Email sending is switched off',
  trengo_live_send_disabled: 'WhatsApp sending is switched off',
  contact_or_template_changed: 'The contact, language or template changed after the message was prepared',
  send_outcome_unconfirmed: 'The send did not finish in time, so it is not confirmed whether the message went out',
  send_outcome_unknown: 'It is not confirmed whether the message was sent',
  email_creation_outcome_unknown: 'It is not confirmed whether the email was queued',
  email_creation_failed: 'The email could not be prepared',
  email_provider_failed: 'The email service rejected the message',
  mailgun_request_failed: 'The email service could not accept the message',
  trengo_request_failed: 'The WhatsApp service rejected the message',
  trengo_outcome_unknown: 'It is not confirmed whether the WhatsApp message was sent',
  provider_delivery_failed: 'The message was sent but not delivered',
  email_send_outcome_unknown: 'It is not confirmed whether the email was sent',
  mailgun_permanent_fail: 'The email came back: the address does not accept messages',
  whatsapp_delivery_failed: 'The WhatsApp message was not delivered',
  insurance_dispatch_outcome_unknown: 'The WhatsApp request did not finish, so it is not confirmed whether the message went out'
}

const STATUS_LABELS = {
  not_prepared: 'Not prepared',
  blocked: 'Cannot send yet',
  ready: 'Ready to send',
  sending: 'Sending',
  accepted: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  read: 'Read',
  failed: 'Failed',
  unknown: 'Needs checking'
}

const LANGUAGE_SOURCES = { client: 'from the client profile', lead: 'from the lead', default: 'default' }

export function statusLabel(status) { return STATUS_LABELS[status] || status || 'Not prepared' }
export function reasonLabel(reason) { return reason ? (REASONS[reason] || reason) : '—' }
export function statusTone(status) {
  if (status === 'failed') return 'red'
  if (['blocked', 'unknown'].includes(status)) return 'amber'
  if (['ready', 'sending'].includes(status)) return 'blue'
  if (status === 'not_prepared' || !status) return 'neutral'
  return 'green'
}
export function channelHint(channel, status, reason) {
  const label = channel === 'email' ? 'Email' : 'WhatsApp'
  return `${label}: ${statusLabel(status)}${reason ? ` · ${reasonLabel(reason)}` : ''}`
}
export function dateOnly(value) {
  if (!value) return '—'
  const date = new Date(`${value}T12:00:00`)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}
export function dateTime(value) {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
}
export function daysLabel(days) {
  if (days === null || days === undefined) return '—'
  if (days < 0) {
    const overdue = Math.abs(days)
    return `Arrived ${overdue} ${overdue === 1 ? 'day' : 'days'} ago`
  }
  return days === 0 ? 'Arrives today' : `${days} ${days === 1 ? 'day' : 'days'} left`
}
export function languageLabel(language, source) {
  if (!language) return '—'
  return `${language.toUpperCase()} (${LANGUAGE_SOURCES[source] || LANGUAGE_SOURCES.default})`
}
export function operationRoute(delivery) {
  return {
    name: `tech-support-message-operations-${delivery.channel}`,
    query: { operation: delivery.operation_id }
  }
}
